import {DESKTOP, PHONE, TABLET} from '../../wizard/constants/GlobalConstants';

export const timeInMinutesForCookie = (days: number = 0, minutes: number = 0) => {
    if (days) {
        return days;
    }
    return new Date(new Date().getTime() + minutes * 60000);
};

export const typeByDevice = (isTablet, isPhone) => {
    if (isTablet) {
        return TABLET;
    }
    if (isPhone) {
        return PHONE;
    }
    return DESKTOP;
};

export const appendNumberToAllKeysOfAnOnObject = (number: number, object: Object) =>
    Object.assign({}, ...Object.keys(object).map(key => ({[`${key}${number}`]: object[key]})));

export const calculatePercentage = (totalSteps = 0, currentStep = 0) =>
    (currentStep * 100) / totalSteps;

export const bytesToHumanFileSize = (size) => {
    const i = Math.floor(Math.log(size) / Math.log(1024));
    return (
        Number((size / Math.pow(1024, i)).toFixed(2)) * 1 +
        ' ' +
        ['B', 'KB', 'MB', 'GB', 'TB'][i]
    );
};
